import React from 'react'

const DigitalMarketingServicesSection = () => {
  return (
    <div>
      <style>{`
            .thick-border{
                border-bottom: 5px solid #18336c;
                width:30%;
                margin-bottom: 1rem;
                transition: width 0.3s ease;
            }

            .media-body h3{
                margin-bottom: -0.1rem;
            }

            .media-body:hover .thick-border {
                width: 50%;
            }

            .hr-divider{
                background-color: gray;
                padding: 2px;
            }

        `}</style>

      <div className="counter-area-4 overflow-hidden space-bottom">
        <div className="container th-container5">
          <h2 className="text-center pb-4">
            Warrgyizmorsch' Digital Marketing Services
          </h2>
          <div className="counter-card4-wrap">
            <div className="counter-card4">
              <div className="media-body">
                <h3 className="">Search Engine Optimization</h3>
                <div className="thick-border"></div>
                <p className="counter-text mb-0">
                  Boost your website with advanced ranking and best SEO
                  strategies to improve website ranking. Our strategy is for
                  both off-page and on-page techniques. It helps in improving
                  the website's search engine ranking. It helps in driving
                  organic traffic to the website to improve website visibility.
                  And to attract potential customers for seeking the products or
                  the services.
                </p>
              </div>
            </div>
            <div className="divider"></div>
            <div className="counter-card4">
              <div className="media-body">
                <h3 className="">
                  Technical <br />
                  SEO
                </h3>
                <div className="thick-border"></div>
                <p className="counter-text mb-0">
                  To enhance the performance of the website with structured
                  data, mobile optimization, and speed improvement. Our experts
                  optimize the site structure, speed, and responsiveness of the
                  website. It also helps in enhancing the performance of the
                  website. They assure that SEO techniques can crawl the website
                  easily. So that it improves the ranking and user experience.
                </p>
              </div>
            </div>
            <div className="divider"></div>
            <div className="counter-card4">
              <div className="media-body">
                <h3 className="">Custom Website Design</h3>
                <div className="thick-border"></div>
                <p className="counter-text mb-0">
                  With the best custom website development for the businesses to
                  improve branding. Our custom website design services focus on
                  the unique site for better functionalities and
                  user-friendliness of the website. This helps in designing the
                  website with different approaches of the business for this
                  competitive online landscape.
                </p>
              </div>
            </div>
            <div className="divider"></div>
          </div>
          <hr className="hr-divider" />
          <div className="counter-card4-wrap">
            <div className="counter-card4">
              <div className="media-body">
                <h3 className="">eCommerce Marketing</h3>
                <div className="thick-border"></div>
                <p className="counter-text mb-0">
                  E-commerce marketing helps in driving sales with a given
                  target audience. Our e-commerce marketing strategies include
                  PPC advertising, SEO, email marketing, and retargeting
                  campaigns. This business is designed to maximize sales and
                  enhance the customer experience to improve business growth.
                </p>
              </div>
            </div>
            <div className="divider"></div>
            <div className="counter-card4">
              <div className="media-body">
                <h3 className="">
                  Content <br />
                  Writing
                </h3>
                <div className="thick-border"></div>
                <p className="counter-text mb-0">
                  High-quality content for the website, blogs, articles, and
                  marketing materials. We provide optimized informative content
                  for use. Well-designed content helps in grabbing new
                  customers. Also helps in engaging the audience to the website.
                  Content is an important part of improving the search engine
                  ranking.
                </p>
              </div>
            </div>
            <div className="divider"></div>
            <div className="counter-card4">
              <div className="media-body">
                <h3 className="">Social Media Marketing</h3>
                <div className="thick-border"></div>
                <p className="counter-text mb-0">
                  To improve brand awareness and engagement using social media
                  marketing. Developed the campaign strategy for the social
                  media account. With the aim of brand awareness, engagement,
                  and lead generation. Choosing the platform where the audience
                  is most active and easy to catch for meaningful interactions.
                </p>
              </div>
            </div>
            <div className="divider"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DigitalMarketingServicesSection
